<template>
  <div class="form-group position-relative">
    <label class="font-size-12">{{ label }}</label>
    <input ref="inputValue" v-model="iValue" :type="(unit === 'px' && valueType === 'integer') ? 'text' : 'number'" class="form-control" :placeholder="placeholder" :disabled="disabled" :style="{ paddingRight: '25px' }" />
    <span class="unit position-absolute" :style="{ top: '36px', right: '8px' }">{{ unit }}</span>
  </div>
</template>

<script>
export default {
  props: {
    value: { type: [Number, String], default: '' },
    label: { type: [String], default: '' },
    placeholder: { type: [String], default: '' },
    unit: { type: [String], default: 'px' },
    valueType: { type: [String], default: 'default' },
    disabled: { type: Boolean, default: false }
  },
  computed: {
    iValue: {
      get() { return this.value },
      set(newVal) {
        newVal = newVal.trim()
        if (this.unit === '%') {
          // For Positive Integers
          newVal = this.calcPositiveInteger(newVal, 0, 100, this.$refs)
        } else if (this.unit === 'px') {
          if (this.valueType === 'default') {
            // For Positive Integers
            newVal = this.calcPositiveInteger(newVal, 0, 2000, this.$refs)
          } else if (this.valueType === 'number') {
            // For Positive Integers
            newVal = this.calcPositiveInteger(newVal, 0, 300, this.$refs)
          } else if (this.valueType === 'integer') {
            // For Integers
            let forceSet = true
            if (newVal === '' || newVal === '-' || isNaN(newVal)) {
              if (newVal === '' || newVal === '-') forceSet = false
              else newVal = 0
            } else if (parseFloat(newVal) < -300) {
              newVal = -300
            } else if (parseFloat(newVal) > 300) {
              newVal = 300
            }
            if (forceSet) {
              newVal = parseInt(parseFloat(newVal))
              this.$refs.inputValue.value = newVal
            }
          }
        }
        this.$emit('input', newVal)
        this.$emit('change', this)
      }
    }
  },
  methods: {
    calcPositiveInteger(newVal, min = 0, max = 100, $refs) {
      let shouldEmpty = false
      if (newVal === '' || isNaN(newVal)) {
        if (newVal === '') shouldEmpty = true
        else newVal = 0
      } else if (parseFloat(newVal) < min) newVal = min
      else if (parseFloat(newVal) > max) newVal = max
      if (shouldEmpty) $refs.inputValue.value = ''
      else {
        newVal = parseInt(parseFloat(newVal))
        $refs.inputValue.value = newVal
      }
      return newVal
    }
  }
}
</script>